var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0241 16.5904H2.97589C1.41779 16.5904 0.15 15.3226 0.15 13.7645V5.88214C0.15 4.32404 1.41779 3.05625 2.97589 3.05625H14.0241C15.5822 3.05625 16.85 4.32404 16.85 5.88214V13.7645C16.85 15.3226 15.5822 16.5904 14.0241 16.5904ZM2.97589 4.48906C2.20768 4.48906 1.58281 5.11393 1.58281 5.88214V13.7645C1.58281 14.5327 2.20768 15.1576 2.97589 15.1576H14.0241C14.7923 15.1576 15.4172 14.5327 15.4172 13.7645V5.88214C15.4172 5.11393 14.7923 4.48906 14.0241 4.48906H2.97589Z",
    fill: "#3B3B3B",
    stroke: "#F2F7FF",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0754 8.99101H0.866404C0.47086 8.99101 0.15 8.67015 0.15 8.27461C0.15 7.87906 0.47086 7.5582 0.866404 7.5582H16.0754C16.471 7.5582 16.7918 7.87906 16.7918 8.27461C16.7918 8.67018 16.4712 8.99101 16.0754 8.99101Z",
    fill: "#3B3B3B",
    stroke: "#F2F7FF",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0835 1.76796V1.61796H9.93347H6.95937H6.80937V1.76796V3.77158C6.80937 4.16712 6.48851 4.48798 6.09297 4.48798C5.69742 4.48798 5.37656 4.16712 5.37656 3.77158V1.75872C5.37656 0.891068 6.08274 0.185156 6.95012 0.185156H9.94272C10.8104 0.185156 11.5163 0.891333 11.5163 1.75872V3.77158C11.5163 4.16738 11.1955 4.48798 10.7999 4.48798C10.4043 4.48798 10.0835 4.16712 10.0835 3.77158V1.76796Z",
    fill: "#3B3B3B",
    stroke: "#F2F7FF",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8977 10.5395C11.5021 10.5395 11.1813 10.2186 11.1813 9.8231V8.27461C11.1813 7.87906 11.5021 7.5582 11.8977 7.5582C12.2932 7.5582 12.6141 7.87906 12.6141 8.27461V9.8228C12.6141 10.2187 12.2932 10.5395 11.8977 10.5395Z",
    fill: "#3B3B3B",
    stroke: "#F2F7FF",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12617 10.5395C4.73063 10.5395 4.40977 10.2186 4.40977 9.8231V8.27461C4.40977 7.87906 4.73063 7.5582 5.12617 7.5582C5.52171 7.5582 5.84257 7.87906 5.84257 8.27461V9.8228C5.84257 10.2187 5.52168 10.5395 5.12617 10.5395Z",
    fill: "#3B3B3B",
    stroke: "#F2F7FF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIcon);
export default __webpack_public_path__ + "static/media/suitcase_icon.e33b8b51d107fd932a3153dcf8c662d2.svg";
export { ForwardRef as ReactComponent };